import React, {useCallback,useEffect,useState}from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faStar, faUsers, faClock, faPlay, 
  faCheckCircle, faChartBar, faChartLine,
  faDatabase, faProjectDiagram, faLaptopCode, 
  faCertificate, faBriefcase, faMedal, faTrophy, faCrown
} from '@fortawesome/free-solid-svg-icons';
import './HeroSection.css';

const PowerBi = () => {
   const [showModal, setShowModal] = useState(false);
        const [formCourseName, setFormCourseName] = useState('Power BI');
        const [formData, setFormData] = useState({
          fullName: '',
          mobileNumber: '',
          email: '',
        });
      
        const openModal = () => setShowModal(true);
        const closeModal = useCallback(() => {
          setShowModal(false);
          setFormData({ fullName: '', mobileNumber: '', email: '' });
        }, []);
      
        useEffect(() => {
          const handleEsc = (e) => {
            if (e.key === 'Escape') closeModal();
          };
          window.addEventListener('keydown', handleEsc);
          return () => window.removeEventListener('keydown', handleEsc);
        }, [closeModal]);
      
        const handleInputChange = (e) => {
          const { name, value } = e.target;
          if (name === 'mobileNumber') {
            const digitsOnly = value.replace(/\D/g, '');
            if (digitsOnly.length <= 10) {
              setFormData(prev => ({ ...prev, [name]: digitsOnly }));
            }
          } else {
            setFormData(prev => ({ ...prev, [name]: value }));
          }
        };
      
        const handleSubmit = async (e) => {
          e.preventDefault();
          const { fullName, mobileNumber, email } = formData;
      
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
          if (!fullName || !emailRegex.test(email) || mobileNumber.length !== 10) {
            alert('Please fill in valid details.');
            return;
          }
      
          try {
            const response = await fetch('https://api.dikshasea.in/api/enrollments', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ ...formData, course: formCourseName }),
            });
      
            const result = await response.json();
            if (response.ok) {
              alert('Enrollment successful!');
              closeModal();
            } else {
              alert(result.message || 'Submission failed');
            }
          } catch (err) {
            console.error(err);
            alert('Error submitting form');
          }
        };
      
  return (
    <>
      <section className="hero-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <span className="badge bg-primary bg-opacity-10 text-white mb-3">New Power BI Certification</span>
              <h1 className="hero-title">
                Master <span className="hero-highlight">Power BI</span>
              </h1>
              <p className="hero-subtitle">
                Become a Power BI expert with our comprehensive certification program. 
                Gain hands-on experience with data modeling, visualization, and dashboard design 
                to transform business data into actionable insights.
              </p>
              
              <div className="course-meta">
                <div className="meta-item">
                  <div className="meta-icon">
                    <FontAwesomeIcon icon={faStar} />
                  </div>
                  <div>
                    <div className="fw-bold">4.8/5.0</div>
                    <small className="text-muted">(4,100 reviews)</small>
                  </div>
                </div>
                <div className="meta-item">
                  <div className="meta-icon">
                    <FontAwesomeIcon icon={faUsers} />
                  </div>
                  <div>
                    <div className="fw-bold">22,000+</div>
                    <small className="text-muted">Certified Professionals</small>
                  </div>
                </div>
                <div className="meta-item">
                  <div className="meta-icon">
                    <FontAwesomeIcon icon={faClock} />
                  </div>
                  <div>
                    <div className="fw-bold">70 hours</div>
                    <small className="text-muted">Hands-on Practice</small>
                  </div>
                </div>
              </div>
              
             <button className="btn btn-primary btn-lg px-4" onClick={openModal}>
                  Enroll Now
                </button>
            </div>
            <div className="col-lg-6 mt-5 mt-lg-0">
              <div className="ratio ratio-16x9">
                <img 
                  src="subcourses-images/powerbi.jpg" 
                  alt="Power BI Certification Course" 
                  className="img-fluid rounded-3 shadow"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="container">
        <div className="course-details">
          <div className="course-content">
            {/* About Course */}
            <section className="about-course">
              <h2 className="section-title">About This Certification</h2>
              <p>This comprehensive Power BI certification program prepares you for business intelligence and data analyst roles. You'll gain expertise in data transformation, DAX formulas, and interactive dashboard creation used by Fortune 500 companies.</p>
              <p>Through real-world business scenarios and practical exercises, you'll build the skills needed to pass Microsoft Power BI certifications and deliver professional analytics solutions.</p>
            </section>
            
            {/* Curriculum */}
            <section className="curriculum">
              <h2 className="section-title">Certification Path</h2>
              
              <div className="curriculum-item">
                <h3><FontAwesomeIcon icon={faChartBar} className="me-2" /> Module 1: Power BI Fundamentals</h3>
                <p>Master core Power BI concepts and interface</p>
                <div className="topics">
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Data import & transformation</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Basic visualizations</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Report design basics</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Publishing to Service</div>
                </div>
              </div>
              
              <div className="curriculum-item">
                <h3><FontAwesomeIcon icon={faDatabase} className="me-2" /> Module 2: Data Modeling</h3>
                <p>Develop professional data models</p>
                <div className="topics">
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Star schema design</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Relationships & cardinality</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Query Editor techniques</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Performance optimization</div>
                </div>
              </div>
              
              <div className="curriculum-item">
                <h3><FontAwesomeIcon icon={faChartLine} className="me-2" /> Module 3: DAX Mastery</h3>
                <p>Master the Data Analysis Expressions language</p>
                <div className="topics">
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Calculated columns & measures</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Time intelligence functions</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Filter context</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Advanced DAX patterns</div>
                </div>
              </div>
              
              <div className="curriculum-item">
                <h3><FontAwesomeIcon icon={faProjectDiagram} className="me-2" /> Module 4: Advanced Visualization</h3>
                <p>Create enterprise-grade dashboards</p>
                <div className="topics">
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Custom visuals</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Drill-through & bookmarks</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Power BI Service features</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Mobile optimization</div>
                </div>
              </div>
              
              <div className="curriculum-item">
                <h3><FontAwesomeIcon icon={faBriefcase} className="me-2" /> Module 5: Enterprise Deployment</h3>
                <p>Implement Power BI at organizational scale</p>
                <div className="topics">
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Workspaces & apps</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Row-level security</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Dataflows & datasets</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Premium capacity</div>
                </div>
              </div>
            </section>
          </div>  
          
         <div className="course-sidebar">
  <div className="info-item">
    <div className="info-icon">
      <FontAwesomeIcon icon={faClock} />
    </div>
    <div className="info-content">
      <h4>Duration</h4>
      <p>10 Weeks (15 hrs/week)</p>
    </div>
  </div>

  <div className="info-item">
    <div className="info-icon">
      <FontAwesomeIcon icon={faCertificate} />
    </div>
    <div className="info-content">
      <h4>Certifications</h4>
      <p>PL-300: Power BI Data Analyst</p>
      <p>Microsoft Certified: Data Analyst Associate</p>
    </div>
  </div>

  <div className="info-item">
    <div className="info-icon">
      <FontAwesomeIcon icon={faLaptopCode} />
    </div>
    <div className="info-content">
      <h4>Projects</h4>
      <p>5 Portfolio Dashboards</p>
    </div>
  </div>

  <div className="info-item">
    <div className="info-icon">
      <FontAwesomeIcon icon={faUsers} />
    </div>
    <div className="info-content">
      <h4>Prerequisites</h4>
      <p>Basic Excel Knowledge</p>
      <p>No Prior Power BI Needed</p>
    </div>
  </div>

  <div className="info-item">
    <div className="info-icon">
      <FontAwesomeIcon icon={faBriefcase} />
    </div>
    <div className="info-content">
      <h4>Career Support</h4>
      <p>Resume Preparation</p>
      <p>BI Interview Coaching</p>
    </div>
  </div>

  {/* 🎖️ Level-based Rewards Section */}
  <div className="info-item reward-section">
    <div className="info-icon">
      <FontAwesomeIcon icon={faStar} />
    </div>
    <div className="info-content">
      <h4>Course Rewards</h4>
      <ul style={{ paddingLeft: '1rem' }}>
        <li>
          <FontAwesomeIcon icon={faMedal} className="me-2 text-warning" />
          <strong>Beginner Level:</strong> Certificate of Completion
        </li>
        <li>
          <FontAwesomeIcon icon={faTrophy} className="me-2 text-primary" />
          <strong>Intermediate Level:</strong> Power BI Project Badge
        </li>
        <li>
          <FontAwesomeIcon icon={faCrown} className="me-2 text-success" />
          <strong>Advanced Level:</strong> Microsoft Certification & Job Readiness Award
        </li>
      </ul>
    </div>
  </div>

  <a
    href="#enroll"
    className="enroll-button"
    style={{ display: "block", textAlign: "center", marginTop: "2rem" }}
  >
    Enroll Now
  </a>
</div>

        </div>
      </div>
      {/* MODAL */}
      {showModal && (
        <div
          className="modal d-block fade show"
          style={{ background: 'rgba(0,0,0,0.5)' }}
          onClick={(e) => { if (e.target === e.currentTarget) closeModal(); }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content p-4 d-flex flex-column flex-md-row">
              <div className="w-100 w-md-50 mb-3 mb-md-0">
                <img
                  src="/img/enroll.jpg"
                  alt="Enrollment"
                  className="img-fluid h-100"
                  style={{ objectFit: 'cover', width: '100%' }}
                />
              </div>
              <div className="w-100 w-md-50 ps-md-4">
                <h6 className="text-primary">Course:</h6>
                <h4 className="fw-bold">Power BI</h4>
                <form onSubmit={handleSubmit} noValidate>
                  <input
                    className="form-control mb-3"
                    type="text"
                    name="fullName"
                    placeholder="Full Name"
                    value={formData.fullName}
                    onChange={handleInputChange}
                    required
                  />
                  <input
                    className="form-control mb-3"
                    type="text"
                    name="mobileNumber"
                    placeholder="Mobile Number"
                    value={formData.mobileNumber}
                    onChange={handleInputChange}
                    required
                    maxLength={10}
                  />
                  <input
                    className="form-control mb-3"
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                  <div className="d-flex justify-content-end">
                    <button type="button" className="btn btn-outline-dark me-2" onClick={closeModal}>
                      Cancel
                    </button>
                    <button type="submit" className="btn btn-primary">Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PowerBi;